import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { searchgame, searchplatform, searchchannel, searchpkg } from "@/api/dataAll/dataAll";
import { payconfig, adpaysdkconfig, uppostsdkconfig } from "@/api/aymentsdk/aymentsdk";
import axios from "axios";
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        id: "",
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        callback_url: "",
        callback_id: "",
        callback_key: "",
        expand_parameter: {}
      },
      ex_Val: [],
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      rules: {
        game: [{
          required: true,
          message: "游戏",
          trigger: "blur"
        }],
        platform: [{
          required: true,
          message: "平台",
          trigger: "blur"
        }],
        channel: [{
          required: true,
          message: "渠道",
          trigger: "blur"
        }],
        pkg: [{
          required: true,
          message: "包名",
          trigger: "blur"
        }],
        callback_url: [{
          required: true,
          message: "请输入回调地址",
          trigger: "blur"
        }],
        callback_id: [{
          required: true,
          message: "请输入回调密钥ID",
          trigger: "blur"
        }],
        callback_key: [{
          required: true,
          message: "请输入回调密钥key",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {
    var _this = this;

    searchgame().then(function (res) {
      _this.searchgames = res.data;
      _this.gameId = res.data.id;
    });
  },
  methods: {
    init: function init(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var expand_parameter, key;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.dialogFormVisible = true;

                if (!data) {
                  _context.next = 11;
                  break;
                }

                _context.next = 4;
                return _this2.gamechange(data.game);

              case 4:
                _context.next = 6;
                return _this2.platformchange(data.platform);

              case 6:
                _context.next = 8;
                return _this2.channelchange(data.channel);

              case 8:
                _this2.searchData = _objectSpread(_objectSpread({}, _this2.searchData), data);
                expand_parameter = JSON.parse(data.expand_parameter);

                for (key in expand_parameter) {
                  _this2.ex_Val.push({
                    name: key,
                    value: expand_parameter[key]
                  });
                }

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    gamechange: function gamechange(game_mark) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.searchData.platform = "";
        _this3.searchData.channel = "";
        _this3.searchData.pkg = "";
        _this3.searchData.advLocation = "";
        _this3.searchchannels = [];
        _this3.searchpkgs = [];

        if (game_mark != "") {
          searchplatform({
            game_id: _this3.searchgames.filter(function (item) {
              return item.game_mark == game_mark;
            })[0].id
          }).then(function (res) {
            _this3.searchplatforms = res.data;
            resolve();
          });
        }
      });
    },
    platformchange: function platformchange(platform_mark) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.searchData.channel = "";
        _this4.searchData.pkg = "";
        _this4.searchpkgs = [];

        if (platform_mark != "") {
          searchchannel({
            platform_id: _this4.searchplatforms.filter(function (item) {
              return item.platform_mark == platform_mark;
            })[0].id
          }).then(function (res) {
            _this4.searchchannels = res.data.channel;
            resolve();
          });
        }
      });
    },
    channelchange: function channelchange(channel_mark) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _this5.searchData.pkg = "";
        _this5.searchpkgs = [];

        if (channel_mark != "") {
          searchpkg({
            channel_id: _this5.searchchannels.filter(function (item) {
              return item.channel_mark == channel_mark;
            })[0].id
          }).then(function (res) {
            _this5.searchpkgs = res.data;
            resolve();
          });
        }
      });
    },
    removeDomain: function removeDomain(item) {
      var index = this.ex_Val.indexOf(item);

      if (index !== -1) {
        this.ex_Val.splice(index, 1);
      }
    },
    addDomain: function addDomain() {
      this.ex_Val.push({
        name: "",
        value: ""
      });
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        game: "",
        platform: "",
        channel: "",
        pkg: "",
        callback_url: "",
        callback_id: "",
        callback_key: "",
        expand_parameter: {}
      };
      this.searchplatforms = [];
      this.searchchannels = [];
      this.searchpkgs = [];
      this.ex_Val = [];
      this.$refs.ruleForm.resetFields();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this6 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = {};

          if (_this6.ex_Val.length > 0) {
            _this6.ex_Val.forEach(function (item, i) {
              data[item.name] = item.value;
            });
          }

          _this6.searchData.expand_parameter = JSON.stringify(data);
          var req = _this6.searchData.id ? uppostsdkconfig : adpaysdkconfig;
          req(_this6.searchData).then(function (res) {
            if (res.status == 200) {
              Message.success('操作成功');

              if (_this6.searchData.id) {
                _this6.$emit("refreshDataList");
              }

              _this6.resetForm("ruleForm");
            }
          });
        }
      });
    }
  }
};